module.exports = __webpack_public_path__ + "img/android.71d42874.svg";